<script>
  import { _ } from 'svelte-i18n'
  import { router } from 'tinro'
  import { onMount } from 'svelte'
  import Loader from '../../../components/Loader.svelte'
  import { dynamicSort, arrayIsEmpty } from 'utils/FormatUtils.svelte'
  import { getData, putData } from '../../../utils/ApiUtils.svelte'
  import {
    currentPage,
    currentCourseId,
    currentCourseName,
    userDetails,
  } from '../../../components/DataStore'
    import CoopIcon from './CoopIcon.svelte';

  let courseList = []

  let courseTableStatus = 'loading'

  let filterSelections = { studentName: '', afterDate: '', beforeDate: '' }

  let heatMap
  let heatMapData = {}

  let page = 0

  let sortColumn = 'customOrder'
  let sortDirection = 1

  onMount(async () => {
    getCourses()
  })

  function getCourses() {
    courseTableStatus = 'loading'
    let sorting = (sortDirection < 0 ? '-' : '') + sortColumn
    getData(`api/courses4?page=${page}&sortBy=${sorting}`)
      .then((data) => {
        console.log('courses successful', data)
        courseList = data
        courseTableStatus = 'ok'
      })
      .catch((error) => {
        console.log('error courses', error)
      })
  }

  function viewCourseDetail(id) {
    console.log('viewCourseDetail', id)
    currentCourseId.update((x) => id)
    clickChangePage('courses-detail/' + id)
  }

  function editCourseDetail(id) {
    console.log('editCourseDetail', id)
    currentCourseId.update((x) => id)
    clickChangePage('courses-edit')
  }

  function clickChangePage(e) {
    console.log('clickChangePage', e)
    currentPage.update((x) => e)
    router.goto('/' + e)
  }

  function changeOrder(column) {
    if (sortColumn === column) {
      sortDirection = -1 * sortDirection
    }
    sortColumn = column

    getCourses()
  }

  function changeCourseOrder(courseId, targetOrder) {
    putData(
      `api/courses/${courseId}/reorder/${targetOrder}`,
      {}
    )
      .then((data) => {
        console.log('change order', data)
        getCourses()
      })
      .catch((error) => {
        courseTableStatus = 'error'
        console.log('error course', error)
      })
  }

  function updatePage(newPage) {
    page = newPage
    getCourses()
  }
</script>

<div style="display: flex;gap: 2em;" />
{#if courseTableStatus != 'ok'}
  <Loader />
{:else if courseList?.totalElements > 0}
  <div
    class="table-responsive table mt-2"
    style="overflow-y: hidden"
    id="dataTable"
    role="grid"
    aria-describedby="dataTable_info"
  >
    <table class="table my-0 table-hover" id="dataTable">
      <thead>
        <tr>
          <th style="width:9em;">#</th>
          <th
            class="sorting"
            on:click={() => {
              changeOrder('name')
            }}
          >
            {#if sortColumn === 'name'}
              {#if sortDirection < 0}
                <i class="fas fa-caret-down mr-1" />
              {:else}
                <i class="fas fa-caret-up mr-1" />
              {/if}

              <strong>{$_('COURSE_NAME')}</strong>
            {:else}
              {$_('COURSE_NAME')}
            {/if}
          </th>

          <th
            class="sorting"
            style="width:7em;"
            on:click={() => {
              changeOrder('studentAccountCount')
            }}
          >
            {#if sortColumn === 'studentAccountCount'}
              {#if sortDirection < 0}
                <i class="fas fa-caret-down mr-1" />
              {:else}
                <i class="fas fa-caret-up mr-1" />
              {/if}

              <strong>{$_('STUDENT_ACCOUNT_COUNT')}</strong>
            {:else}
              {$_('STUDENT_ACCOUNT_COUNT')}
            {/if}
          </th>

          <th
            class="sorting"
            style="width:7em;"
            on:click={() => {
              changeOrder('recordingCount')
            }}
          >
            {#if sortColumn === 'recordingCount'}
              {#if sortDirection < 0}
                <i class="fas fa-caret-down mr-1" />
              {:else}
                <i class="fas fa-caret-up mr-1" />
              {/if}

              <strong>{$_('RECORDING_COUNT')}</strong>
            {:else}
              {$_('RECORDING_COUNT')}
            {/if}
          </th>

          <th
            class="sorting"
            style="width:11em;"
            on:click={() => {
              changeOrder('recordingLastDate')
            }}
          >
            {#if sortColumn === 'recordingLastDate'}
              {#if sortDirection < 0}
                <i class="fas fa-caret-down mr-1" />
              {:else}
                <i class="fas fa-caret-up mr-1" />
              {/if}

              <strong>{$_('LAST_RECORDING')}</strong>
            {:else}
              {$_('LAST_RECORDING')}
            {/if}
          </th>

          <th
            class="sorting"
            style="width:7em;"
            on:click={() => {
              changeOrder('createdAt')
            }}
          >
            {#if sortColumn === 'createdAt'}
              {#if sortDirection < 0}
                <i class="fas fa-caret-down mr-1" />
              {:else}
                <i class="fas fa-caret-up mr-1" />
              {/if}

              <strong>{$_('CREATED_AT')}</strong>
            {:else}
              {$_('CREATED_AT')}
            {/if}
          </th>
        </tr>
      </thead>
      <tbody>
        {#each courseList?.content as l, i}
          <tr
            class="lessonRow"
            on:click={(x) => {
              viewCourseDetail(l?.id)
            }}
          >
            <th scope="row"
              >{courseList?.pageable.offset + i + 1}<span class="ms-1"
                ><a
                  on:click|stopPropagation={(e) => {
                    console.log(888, e)
                  }}
                  href={`#/courses-detail/${l?.id}`}
                  target="_blank"
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 30 30"
                    width="1em"
                    height="1em"
                    ><path
                      d="M 25.980469 2.9902344 A 1.0001 1.0001 0 0 0 25.869141 3 L 20 3 A 1.0001 1.0001 0 1 0 20 5 L 23.585938 5 L 13.292969 15.292969 A 1.0001 1.0001 0 1 0 14.707031 16.707031 L 25 6.4140625 L 25 10 A 1.0001 1.0001 0 1 0 27 10 L 27 4.1269531 A 1.0001 1.0001 0 0 0 25.980469 2.9902344 z M 6 7 C 4.9069372 7 4 7.9069372 4 9 L 4 24 C 4 25.093063 4.9069372 26 6 26 L 21 26 C 22.093063 26 23 25.093063 23 24 L 23 14 L 23 11.421875 L 21 13.421875 L 21 16 L 21 24 L 6 24 L 6 9 L 14 9 L 16 9 L 16.578125 9 L 18.578125 7 L 16 7 L 14 7 L 6 7 z"
                    /></svg
                  ></a
                ></span
              >
              <button
                class="arrows"
                on:click|stopPropagation={(e) => {
                  e.preventDefault()
                  changeCourseOrder(l?.id, l?.customOrder - 1)
                }}>↑</button
              ><button
                class="arrows"
                on:click|stopPropagation={(e) => {
                  e.preventDefault()
                  changeCourseOrder(l?.id, l?.customOrder + 2)
                }}>↓</button
              >
              {#if l?.teacherUserId !== $userDetails?.id}<CoopIcon></CoopIcon>
              {/if}
            </th>
            <td>{l?.name}</td>
            <td>{l?.studentAccountCount}</td>
            <td>{l?.recordingCount}</td>
            <td
              >{#if l?.recordingLastDate}{new Date(
                  Date.parse(l?.recordingLastDate + 'Z')
                ).toLocaleString()}{/if}</td
            >

            <td
              >{new Date(
                Date.parse(l?.createdAt + 'Z')
              ).toLocaleDateString()}</td
            >
          </tr>
        {/each}
      </tbody>
      <tfoot />
    </table>
  </div>
  <nav aria-label="Page navigation example">
    <ul class="pagination flex-wrap justify-content-center">
      <li class="page-item" class:disabled={page === 0}>
        <button
          class="page-link"
          on:click={() => updatePage(0)}
          aria-label="Previous"
        >
          <span aria-hidden="true">&laquo;</span>
          <span class="sr-only">Previous</span>
        </button>
      </li>
      <li class="page-item" class:disabled={page === 0}>
        <button
          class="page-link"
          on:click={() => updatePage(page - 1)}
          aria-label="Previous"
        >
          <span aria-hidden="true">&lsaquo;</span>
          <span class="sr-only">Previous</span>
        </button>
      </li>

      {#if courseList?.totalPages > 8}
        {#if page < 3}
          {#each Array(3) as _, i}
            <li class="page-item" class:active={page === i}>
              <button class="page-link" on:click={() => updatePage(i)}
                >{i + 1}</button
              >
            </li>
          {/each}
          <li class="page-item">
            <button class="page-link" disabled>...</button>
          </li>
        {:else if page > courseList?.totalPages - 3}
          <li class="page-item">
            <button class="page-link" disabled>...</button>
          </li>
          {#each Array(3) as _, i}
            <li
              class="page-item"
              class:active={page === courseList?.totalPages - 3 + i}
            >
              <button class="page-link" on:click={() => updatePage(i)}
                >{courseList?.totalPages - 3 + i + 1}</button
              >
            </li>
          {/each}
        {:else}
          <li class="page-item">
            <button class="page-link" disabled>...</button>
          </li>
          <li class="page-item" class:active={false}>
            <button class="page-link" on:click={() => updatePage(page)}
              >{page}</button
            >
          </li>
          <li class="page-item" class:active={true}>
            <button class="page-link" on:click={() => updatePage(page + 1)}
              >{page + 1}</button
            >
          </li>
          <li class="page-item" class:active={false}>
            <button class="page-link" on:click={() => updatePage(page + 2)}
              >{page + 2}</button
            >
          </li>
          <li class="page-item">
            <button class="page-link" disabled>...</button>
          </li>
        {/if}
      {:else}
        {#each Array(courseList?.totalPages) as _, i}
          <li class="page-item" class:active={page === i}>
            <button class="page-link" on:click={() => updatePage(i)}
              >{i + 1}</button
            >
          </li>
        {/each}
      {/if}
      <li
        class="page-item"
        class:disabled={courseList?.totalPages === courseList?.number + 1}
      >
        <button
          class="page-link"
          on:click={() => updatePage(page + 1)}
          aria-label="Next"
        >
          <span aria-hidden="true">&rsaquo;</span>
          <span class="sr-only">Next</span>
        </button>
      </li>
      <li
        class="page-item"
        class:disabled={courseList?.totalPages === courseList?.number + 1}
      >
        <button
          class="page-link"
          on:click={() => updatePage(courseList?.totalPages - 1)}
          aria-label="Next"
        >
          <span aria-hidden="true">&raquo;</span>
          <span class="sr-only">Next</span>
        </button>
      </li>
    </ul>
  </nav>

  <div class="row">
    <div class="col-md-6 align-self-center">
      <p
        id="dataTable_info"
        class="dataTables_info"
        role="status"
        aria-live="polite"
      >
        {courseList?.totalElements}
        {$_('RESULT_COUNT')}
      </p>
    </div>
    <div class="col-md-6">
      <nav
        class="d-lg-flex justify-content-lg-end dataTables_paginate paging_simple_numbers"
      />
    </div>
  </div>
{:else}
  <div class="row">
    <svg
      class="text-center"
      width="201"
      height="200"
      viewBox="0 0 201 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M102.5 89.3701C99.7311 89.3701 97.0243 88.549 94.722 87.0107C92.4197 85.4724 90.6253 83.2859 89.5657 80.7277C88.5061 78.1695 88.2288 75.3546 88.769 72.6389C89.3092 69.9231 90.6426 67.4286 92.6005 65.4706C94.5584 63.5127 97.053 62.1793 99.7687 61.6391C102.484 61.0989 105.299 61.3762 107.858 62.4358C110.416 63.4954 112.602 65.2899 114.141 67.5921C115.679 69.8944 116.5 72.6012 116.5 75.3701C116.484 79.0783 115.004 82.6301 112.382 85.2522C109.76 87.8743 106.208 89.3543 102.5 89.3701Z"
        fill="#DCDCDC"
      />
      <path
        d="M119.59 115.08L151.95 74.8998L139.36 64.8198L115.02 93.9998H85.39C82.5024 94.013 79.7371 95.1673 77.6971 97.2111C75.6571 99.2548 74.5079 102.022 74.5 104.91V117.34H119.58L119.59 115.08Z"
        fill="#DCDCDC"
      />
      <path
        d="M103.61 87.5698C100.841 87.5698 98.1347 86.7487 95.8324 85.2104C93.5301 83.6721 91.7357 81.4856 90.676 78.9274C89.6164 76.3692 89.3392 73.5543 89.8794 70.8386C90.4196 68.1228 91.7529 65.6283 93.7109 63.6703C95.6688 61.7124 98.1634 60.379 100.879 59.8388C103.595 59.2986 106.41 59.5759 108.968 60.6355C111.526 61.6951 113.713 63.4896 115.251 65.7918C116.789 68.0941 117.61 70.8009 117.61 73.5698C117.595 77.278 116.115 80.8298 113.492 83.4519C110.87 86.074 107.319 87.554 103.61 87.5698ZM103.61 65.7998C102.071 65.7979 100.566 66.2525 99.2853 67.1061C98.0046 67.9598 97.0058 69.1742 96.4155 70.5956C95.8251 72.0171 95.6696 73.5817 95.9686 75.0915C96.2677 76.6013 97.0079 77.9885 98.0955 79.0776C99.1832 80.1666 100.569 80.9086 102.079 81.2096C103.588 81.5106 105.153 81.3571 106.575 80.7686C107.998 80.18 109.213 79.1828 110.068 77.9032C110.924 76.6236 111.38 75.119 111.38 73.5798C111.372 71.5206 110.552 69.5478 109.096 68.0908C107.641 66.6337 105.67 65.8104 103.61 65.7998Z"
        fill="#707070"
      />
      <path
        d="M120.71 113.27L153.07 73.09L140.5 63L116.14 92.23H86.4996C83.6181 92.2432 80.8583 93.3937 78.8208 95.4312C76.7832 97.4688 75.6327 100.228 75.6196 103.11V115.54H66.3096V121.76H72.4996V152.85H78.7196V121.76H122.24V152.85H128.5V121.76H134.72V115.54H120.72L120.71 113.27ZM92.7096 115.54V107.77H86.4996V115.54H81.8496V103.11C81.8548 101.877 82.3461 100.697 83.2167 99.8242C84.0873 98.9517 85.267 98.4579 86.4996 98.45H119.05L141.34 71.69L144.34 74.06L114.53 111.06V115.52L92.7096 115.54Z"
        fill="#707070"
      />
      <path
        d="M164.23 121.76H150.23V115.54H158V53.3699H42.9995V115.54H50.7695V121.76H36.7695V47.1499H164.23V121.76Z"
        fill="#707070"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M53.8701 64.25H75.6301V70.47H53.8701V64.25Z"
        fill="#707070"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M53.8701 79.79H67.8701V86H53.8701V79.79Z"
        fill="#707070"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M53.8701 95.3398H67.8701V101.55H53.8701V95.3398Z"
        fill="#707070"
      />
    </svg>
    <h3 class="text-center">{$_('COURSE_TABLE_EMPTY_PROMPT_NEW')}</h3>
    <p style="padding-left:15%; padding-right:15%;">
      {$_('COURSE_TABLE_EMPTY_PROMPT_EXISTING')}
    </p>
  </div>
{/if}

<style>
  .sorting {
    cursor: pointer;
  }

  tr {
    cursor: pointer;
  }

  .arrows {
    color: #fff;
    background-color: #00a094;
    outline: none !important;
    border-bottom: 2px solid #018d83 !important;
    border-radius: 5px;
    border-left: 1px solid #018d83 !important;
    border-right: 1px solid #018d83 !important;
    border-top: 1px solid #018d83 !important;
    margin: 10px 2px 0;
    padding: 0em 0.375em;
  }
</style>
